import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap'

import PDFViewer from '../PDFViewer';
import PDFJSBackend from '../../backends/pdfjs';

export class IsoNova extends Component {
    static displayName = IsoNova.name;

    constructor(props) {
        super(props);
        this.state = {
            viewPdfPath: "/nds.pdf", pdfList: [], pdfListErrors: [], invoices: [], unmergedInvoices: [], loading: true, loading2: true, waiting: false, ModalTitle: "Duplicates", tempPdfs: [], invoicesSelected: [], showModal: false, showModalDuplicates: false, showModalParseEmail: false, contents2: <p><em>No invoices have been added...</em></p>, invoiceCount: 0, emailCount: 0, pdfCount: 0, pdfCountImported: 0, invoiceTotalAmount: 0.00, mergeStatus: <p></p>, parseMessage: "This process will remove any pdfs that are currently stored in temp. Are you sure?", duplicateMessage: <p></p>, generateStatus: <p></p>, targetInvoiceNumber: "", targetMbNumber: "", targetInvoiceStatusValid: false};
        this.addRow = this.addRow.bind(this);
        this.delRow = this.delRow.bind(this);
        this.mergeInvoices = this.mergeInvoices.bind(this);
        this.handleInvoiceInput = this.handleInvoiceInput.bind(this);
        this.handleMbInput = this.handleMbInput.bind(this);
        this.handleInvoicePDFSubmit = this.handleInvoicePDFSubmit.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleParseEmailSubmit = this.handleParseEmailSubmit.bind(this);
        this.openParseEmail = this.openParseEmail.bind(this);
        this.autoAddPdfs = this.autoAddPdfs.bind(this);
        this.CleanPdfs = this.CleanPdfs.bind(this);
        this.GetMissingInvoices = this.GetMissingInvoices.bind(this);
        this.ConfirmDuplicates = this.ConfirmDuplicates.bind(this);
        this.closeParseEmail = this.closeParseEmail.bind(this);
        this.openModalDuplicates = this.openModalDuplicates.bind(this);
        this.closeModalDuplicates = this.closeModalDuplicates.bind(this);
        this.compareValues = this.compareValues.bind(this);
        this.closeWaitingModal = this.closeWaitingModal.bind(this);
        this.openWaitingModal = this.openWaitingModal.bind(this);
        this.updateViewPdf = this.updateViewPdf.bind(this);
        this.ImportCopyHandler = this.ImportCopyHandler.bind(this);
        this.ImportDeleteHandler = this.ImportDeleteHandler.bind(this);
    }

    componentDidMount() {
        // jacob f took out 10/28 for testing cap cap
        //this.populateInvoiceDetailData();
        this.populateFileCountData();
        console.log(this.state.unmergedInvoices);
    }

    updateViewPdf(pdfPath) {
        console.log(pdfPath);
        this.setState({ viewPdfPath: pdfPath});
    }

    displayDuplicates(data) {

        let duplicateCount = "Error count: " + Object.keys(data).length.toString();

        let struct = 
            Object.keys(data).map((key, i) =>
                        <div>
                    <a class="list-group-item list-group-item-action active" id="list-home-list" data-toggle="list" href="#list-home" role="tab" aria-controls="home" key={ i }>{ i + 1 }. { key }</a>

                    {data[key].map((p) => <p><small>{p}</small></p>)}
                        </div>
                    

            )
       
        this.setState({
            generateStatusParseEmail:
                <div class="row">
                    <div class="col">
                        <div class="list-group" id="list-tab" role="tablist">
                            { struct }
                        </div>
                    </div>
                </div>,
            parseMessage: duplicateCount
        });
    }

    open() {
        this.setState({ showModal: true });
    }

    close() {
        this.setState({ showModal: false });
    }

    openParseEmail() {
        this.setState({ showModalParseEmail: true });
    }
    openModalDuplicates(title = "Duplicates") {
        this.setState({ showModalDuplicates: true, ModalTitle: title });
    }
    closeModalDuplicates() {
        this.setState({ showModalDuplicates: false });
    }

    ConfirmDuplicates() {
        this.CheckDuplicates();
        this.openModalDuplicates();
    }

    openWaitingModal() {
        Promise.resolve().then(() => {
            this.setState({ waiting: true });
        });
    }

    closeWaitingModal() {
        this.setState({ waiting: false });
    }

    GetMissingInvoices(defaultPdfList = []) {
        if (defaultPdfList != []) {
            defaultPdfList = this.state.tempPdfs;
        };
        console.log(defaultPdfList);
        var updatedInvoicesSelected = this.state.invoicesSelected;
        var updatedUnmergedInvoices = this.state.unmergedInvoices;
        var invoiceNewTotalAmount = this.state.invoiceTotalAmount;
        var sendChanges = false;
        var changeCount = 0;
        var foundInvoices = [];

        console.log(this.state.invoicesSelected);
        console.log(this.state.unmergedInvoices);
        console.log(this.state.invoiceTotalAmount);

        console.log(updatedUnmergedInvoices);
        if (updatedUnmergedInvoices === []) {
            updatedUnmergedInvoices = this.getInvoiceDetailData();
        }
        console.log(updatedUnmergedInvoices);

        for (let pdf in defaultPdfList) {
            for (let invoice in this.state.unmergedInvoices) {
                if ((this.state.unmergedInvoices[invoice].invoiceNumber === this.state.tempPdfs[pdf].toString()) && updatedInvoicesSelected.indexOf(this.state.unmergedInvoices[invoice]) === -1) {
                    updatedInvoicesSelected.push(this.state.unmergedInvoices[invoice]);
                    invoiceNewTotalAmount = invoiceNewTotalAmount + this.state.unmergedInvoices[invoice].invoiceAmount
                    updatedUnmergedInvoices.splice(invoice, 1);
                    foundInvoices.push(defaultPdfList[pdf]);
                    sendChanges = true;
                    changeCount = changeCount + 1;
                };
            };

        };
        if (sendChanges) {
            this.setState({
                invoicesSelected: updatedInvoicesSelected, loading2: false,
                unmergedInvoices: updatedUnmergedInvoices,
                contents: IsoNova.renderInvoiceDetailTable(updatedUnmergedInvoices.sort(this.compareValues('invoiceNumber')), this.addRow, "Add"),
                contents2: IsoNova.renderInvoiceDetailTable(updatedInvoicesSelected.sort(this.compareValues('invoiceNumber')), this.delRow, "Remove"),
                invoiceCount: this.state.invoiceCount + changeCount,
                invoiceTotalAmount: invoiceNewTotalAmount,
                pdfCountImported: defaultPdfList.length
            });
        }
        console.log(foundInvoices);
        return { errors: defaultPdfList.filter(x => foundInvoices.indexOf(x) === -1), ready: defaultPdfList.filter(x => foundInvoices.indexOf(x) > -1)};
    }

    CleanPdfs() {
        this.cleanPdfs(this.GetMissingInvoices()).then(() => {
            this.populateFileCountData();
        });
    }

    ImportCopyHandler() {
        
        this.openWaitingModal();
        console.log("test");
        this.populateInvoiceDetailData().then(() => {
            console.log("processed successsfully");
        
        let missingInvoices = this.GetMissingInvoices();
        console.log(missingInvoices);
        let missingInvoicesDetail = [];
        let c = 0;
        this.importCopy().then((data) => {
            console.log(data);
            missingInvoices.errors.forEach(function (item) {
                missingInvoicesDetail[c] = { invoiceNumber: item, masterbillNumber: "N/A" };
                if (data["detailedInfo"].length > 0) {
                    data["detailedInfo"].forEach(function (x) {
                        if (x["invoiceNumber"] === item) {
                            missingInvoicesDetail[c] = x;
                        };
                    });
                }
                
                c = c + 1;
            });
            this.populateFileCountData();
        }).then(() => {
            this.setState({
                pdfList: missingInvoices.ready,
                pdfListErrors: missingInvoicesDetail
            });
        }).then(() => {
            this.closeWaitingModal();
        });
        });
    }

    ImportDeleteHandler = (e, param) => {
        e.preventDefault();
        if (this.state.pdfListErrors.length === 0) {
            alert("No records files to delete!");
            return
        }
        this.openWaitingModal();
        let deleteList = "";
        if (param === "delete all") {
            var temp = [];
            this.state.pdfListErrors.forEach(function (item) {
                temp.push(item["invoiceNumber"] + ".pdf")
            })
            deleteList = temp.toString();
        } else {
            deleteList = param + ".pdf";
        };
        //console.log(deleteList);
        this.importDelete(deleteList).then((data) => {
            this.populateFileCountData();
            //console.log(data);
            let missingInvoices = this.GetMissingInvoices();
            let missingInvoicesDetail = [];
            let c = 0;
            //missingInvoices.errors.forEach(function (item) {
            //    missingInvoicesDetail[c] = { invoiceNumber: item, masterbillNumber: "N/A" };
            //    if (data["detailedInfo"].length > 0) {
            //        data["detailedInfo"].forEach(function (x) {
            //            if (x["invoiceNumber"] === item) {
            //                missingInvoicesDetail[c] = x;
            //            };
            //        });
            //    }
            //    c = c + 1;
            //});
            //console.log(this.state.pdfListErrors);
            //console.log(missingInvoicesDetail);
            if (data["detailedInfo"].length > 0) {
                missingInvoicesDetail = data["detailedInfo"]
            }
            this.setState({
                pdfList: missingInvoices.ready,
                pdfListErrors: missingInvoicesDetail
            });

            //console.log(this.state.pdfListErrors);
            
        }).then(() => {
            this.closeWaitingModal();
        });
        
    }

    autoAddPdfs() {

        //setup loading gif
        console.log("Test");
        console.log(this.state.invoicesSelected);
        console.log(this.state.unmergedInvoices);
        console.log(this.state.invoiceTotalAmount);
        this.setState({ duplicateMessage: <p> Loading.....</p> });
        this.openModalDuplicates("Following Invoices were not added: ");
        
        let missingInvoices = this.GetMissingInvoices();
        
        if (missingInvoices.length > 0) {
            var items = missingInvoices.map(it => <li>{it}</li>);
            this.setState({ duplicateMessage: <div><ul>{ items }</ul></div> });
        } else {
            this.setState({ duplicateMessage: <p> None found.</p> });
        };

    }

    closeParseEmail() {
        this.setState({ showModalParseEmail: false });
    }



    handleInvoiceInput = event => {
        this.setState({
            targetInvoiceNumber: event.target.value
        });
    };

    handleMbInput = event => {
        this.setState({
            targetMbNumber: event.target.value
        });
    };

    handleInvoicePDFSubmit = event => {
        //event.preventDefault();
        if (!this.state.targetMbNumber) {
            this.setState({ generateStatus: <p style={{ color: "#AF2526" }}><em>Master bill number required</em></p> });
        } else {
            this.generateMasterBillPDF(this.state.targetMbNumber);
        };
    };

    handleParseEmailSubmit = event => {
        event.preventDefault();

        this.setState({ generateStatusParseEmail: <p style={{ color: "#AF2526" }}><em>processing....</em></p> });
        this.parseEmails();

    };


        addRow(po) {
            var updatedInvoicesSelected = this.state.invoicesSelected;
            var updatedUnmergedInvoices = this.state.unmergedInvoices;
            var invoiceNewTotalAmount = this.state.invoiceTotalAmount;
            var sendChanges = false;
            var changeCount = 0;

            for (let invoice in this.state.unmergedInvoices) {
                if ((this.state.unmergedInvoices[invoice].invoicePONumber === po || this.state.unmergedInvoices[invoice].invoiceNumber === po) && updatedInvoicesSelected.indexOf(this.state.unmergedInvoices[invoice]) === -1 ) {
                    updatedInvoicesSelected.push(this.state.unmergedInvoices[invoice]);
                    invoiceNewTotalAmount = invoiceNewTotalAmount + this.state.unmergedInvoices[invoice].invoiceAmount
                    updatedUnmergedInvoices.splice(invoice, 1);
                    sendChanges = true;
                    changeCount = changeCount + 1;
                };
            };
            if (sendChanges) {
                this.setState({
                    invoicesSelected: updatedInvoicesSelected, loading2: false,
                    unmergedInvoices: updatedUnmergedInvoices,
                    contents: IsoNova.renderInvoiceDetailTable(updatedUnmergedInvoices.sort(this.compareValues('invoiceNumber')), this.addRow, "Add"),
                    contents2: IsoNova.renderInvoiceDetailTable(updatedInvoicesSelected.sort(this.compareValues('invoiceNumber')), this.delRow, "Remove"),
                    invoiceCount: this.state.invoiceCount + changeCount,
                    invoiceTotalAmount: invoiceNewTotalAmount
                });
            }
            
        }

    delRow(po) {
        var updatedInvoicesSelected = this.state.invoicesSelected;
        var updatedUnmergedInvoices = this.state.unmergedInvoices;
        var invoiceNewTotalAmount = this.state.invoiceTotalAmount;
        for (let invoice in this.state.invoicesSelected) {
            if (this.state.invoicesSelected[invoice].invoicePONumber === po) {
                invoiceNewTotalAmount = invoiceNewTotalAmount - this.state.invoicesSelected[invoice].invoiceAmount
                updatedUnmergedInvoices.push(this.state.invoicesSelected[invoice]);
                updatedInvoicesSelected.splice(invoice, 1);
                
            };
        };
        this.setState({
            invoicesSelected: updatedInvoicesSelected, loading2: false,
            unmergedInvoices: updatedUnmergedInvoices,
            contents: IsoNova.renderInvoiceDetailTable(updatedUnmergedInvoices.sort(this.compareValues('invoiceNumber')), this.addRow, "Add"),
            contents2: IsoNova.renderInvoiceDetailTable(updatedInvoicesSelected.sort(this.compareValues('invoiceNumber')), this.delRow, "Remove"),
            invoiceCount: this.state.invoiceCount - 1,
            invoiceTotalAmount: invoiceNewTotalAmount
        });

    }

    compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }

        const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return (
            (order === 'desc') ? (comparison * -1) : comparison
        );
    };
}

    async mergeInvoices() {
        var mergeData = { InvoiceNumber: this.state.targetInvoiceNumber, InvoicePOs: [] };

        if (this.state.invoicesSelected.length === 0) {
            this.setState({ mergeStatus: <p style={{ color: "red" }}><em>No invoices selected. </em></p> });
            return;
        } else {
            this.setState({ mergeStatus: <p></p> });
        };

        for (let invoice in this.state.invoicesSelected) {
            mergeData.InvoicePOs.push(this.state.invoicesSelected[invoice].invoicePONumber);
        };
        const data = await this.validateInvoice(this.state.targetInvoiceNumber);
        if (data) {
            this.mergeInvoiceDetailData(mergeData);
        }
    }

    static renderInvoiceDetailTable(invoices, action, actionName) {
        
        return (
            <table class="table table-hover table-dark">
                            <thead>
                    <tr>
                        <th scope="col">Date</th>
                                    <th scope="col">PO #</th>
                                    <th scope="col">Invoice #</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map(invoice =>
                                    <tr key={invoice.invoicePONumber}>
                                        <td>{invoice.invoiceDate.split('T')[0]}</td>
                                        <td>{invoice.invoicePONumber}</td>
                                        <td>{invoice.invoiceNumber}</td>
                                        <td>{invoice.invoiceAmount}</td>
                                        <td>
                                            <button type="button" class="btn btn-primary" id={`btn-check-outlined-${invoice.invoicePONumber}`} data-toggle="button" aria-pressed="false" autoComplete="off" onClick={() => { action(invoice.invoicePONumber) }}>{ actionName }</button>
                                        </td>
                        </tr>
                    )}
                            </tbody>
                        </table>
        );
    }

    render() {

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : IsoNova.renderInvoiceDetailTable(this.state.unmergedInvoices, this.addRow, "Add");
        return (
            <div>
                <div>
                    <Modal className="modal-container" show={this.state.showModalDuplicates} onHide={this.closeModalDuplicates} animation={true}>
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.ModalTitle}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <form>
                                <div class="container">
                                    <div class="row">{this.state.duplicateMessage}</div>
                                </div>
                            </form>

                        </Modal.Body>
                        <Modal.Footer>
                        </Modal.Footer>

                    </Modal>
                </div>
                <div>
                    <Modal className="modal-container" show={this.state.showModalParseEmail} onHide={this.closeParseEmail} animation={true}>
                        <Modal.Header closeButton>
                            <Modal.Title>Parse Emails</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <form>
                                <div class="container">
                                    <div class="row">
                                        <label class="form-label" for="mbNumber">{this.state.parseMessage}</label>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col"></div>
                                        <div class="col-md-auto">
                                            <Button variant="primary" type="submit" onClick={this.handleParseEmailSubmit}>
                                                Start
                                        </Button>
                                        </div>
                                        <div class="col-md-auto">
                                            <Button variant="primary" type="submit" onClick={this.closeParseEmail}>
                                                Done
                                        </Button>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div>{this.state.generateStatusParseEmail}</div>
                                    </div>
                                </div>


                            </form>

                        </Modal.Body>
                        <Modal.Footer>
                        </Modal.Footer>

                    </Modal>
                    <Modal className="modal-container" show={this.state.waiting} onHide={this.closeWaitingModal} animation={true}>
                        <Modal.Header>
                            <Modal.Title>Processing.....</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
         
                                <div class="container">
                                    <div class="row">
                                        <p>This could take a few minutes.</p>
                                    </div>
                             
                                </div>

                        </Modal.Body>
                        <Modal.Footer>
                        </Modal.Footer>

                    </Modal>
                </div>
        <div class="container-fluid p-5">
            <div class="row">
                        <div class="container d-flex align-items-center justify-content-center">
                    <h1>IsoNova Tank Wash</h1>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col mp-1">
                    <p><strong>Step 1A.</strong> Reset (delete all Emails, Temp and Imports files)</p>
                            <p><strong>Step 1B.</strong> Manually Copy pass-through emails to <span>N:\Invoicing\Isonova\Social Circle\emails</span></p>
                            <p><strong>Step 1C.</strong> <button type="button" class="btn btn-primary pb-1" onClick={() => { this.openParseEmail() }}>Extract</button> PDFs from pass-through emails </p>
                            <p><strong>Step 1D.</strong> <button type="button" class="btn btn-primary pb-1" onClick={() => { this.ImportCopyHandler() }}>Import</button> PDFs</p>
                            <p><strong>Step 1E.</strong> Review and Delete all Error(s)</p>
                            <p><strong>Step 1E.</strong> Confirm Total PDFs = Imported PDFs</p>
                </div>
                <div class="col mp-1">
                            <p><strong>Step 2A.</strong> Add new S# (must be in 'Hold' status in Billing Desk)</p>
                            <p><strong>Step 2B.</strong> <button type="button" class="btn btn-primary" onClick={() => { this.mergeInvoices() }}>Merge</button> imported PDFs into Invoice</p>
                            <p><strong>Step 2C.</strong> <button type="button" class="btn btn-primary pb-1" onClick={() => { this.ConfirmDuplicates() }}>Validation Check</button> to confirm there are no duplicate charges</p>                        </div>
                <div class="col mp-1">
                            <p><strong>Step 3A.</strong> Add any manual pdfs to the Temp folder</p>
                            <p><strong>Step 3B.</strong> <button type="button" class="btn btn-info" onClick={() => { this.handleInvoicePDFSubmit() }}>Generate</button> Invoice Packet</p>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col mp-1">
                    <div class="border border-secondary">
                        <ul class="list-group p-1">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Emails
    <span class="badge badge-primary badge-pill">{this.state.emailCount}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Total PDFs (Temp folder - includes manual and imported)
    <span class="badge badge-primary badge-pill">{this.state.pdfCount}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Imported PDFs
    <span class="badge badge-primary badge-pill">{this.state.pdfCountImported}</span>
                            </li>
                        </ul>
                    </div>

                </div>
                <div class="col mp-1">
                    <div class="border border-secondary">
                        <ul class="list-group p-1">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <input type="text" id="invoiceNumber" class="form-control" onChange={this.handleInvoiceInput} placeholder="Invoice Number..." />
                            </li>
                        </ul>
                        <div class="col text-center">
                            {this.state.contentsInvoiceStatus}
                            {this.state.mergeStatus}
                        </div>

                        <div class="p-2"> </div>
                    </div>

                </div>
                <div class="col mp-1">
                            <div class="border border-secondary">
                                <ul class="list-group p-1">
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <input type="text" id="mbNumber" class="form-control" onChange={this.handleMbInput} value={this.state.targetMbNumber} placeholder="Invoice Master Bill Number..." required />
                                    </li>
                                </ul>
                                <div class="col text-center">
                                    <div class="col">{this.state.generateStatus}</div>
                                </div>
                        <div class="p-2"> </div>
                    </div>

                </div>
            </div>
            <hr/>
            <div class="row m-auto">

                <div style={{ width: "100%" }}>
                    <div class="row">
                        <div class="col-md-2" style={{ backgroundColor: "lightgray" }}>
                                    <span>Imported</span>
                            <ul>
                                {
                                    this.state.pdfList.map((item, i) =>

                                        <li class="pdf-item" onClick={() => this.updateViewPdf("/pdfs/" + item)}>{ item }</li>
                                )
                            }
                            </ul>
                                </div>
                                <div class="col-md-2" style={{ color: "indianred", backgroundColor: "lightgray" }}>
                                    <span>Error(s) - </span><a href="#" onClick={e => this.ImportDeleteHandler(e, "delete all") }>Delete All</a>
                                    <ul>
                                        {
                                            this.state.pdfListErrors.map((item, i) =>

                                                <li key={item.invoiceNumber}><span class="pdf-item" onClick={() => this.updateViewPdf("/pdfs/" + item.invoiceNumber + ".pdf")}>{item.invoiceNumber} ({item.masterbillNumber})</span> - <span class="pdf-item" onClick={e => this.ImportDeleteHandler(e, `${ item.invoiceNumber }`)}>Delete</span></li>
                                            )
                                        }
                                    </ul>
                                </div>
                        <div class="col-md-8" style={{ backgroundColor: "grey" }}>
                            <div id="viewer" style={{ width: "100%", height: "1200px" }}>
                                <iframe src={`/pdfjs-2.16.105-dist/web/viewer.html?file=${this.state.viewPdfPath}`} width="100%" height="100%"></iframe>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

                </div>
            </div>
    );
  }



    async populateInvoiceDetailData() {
        const response = await fetch('invoicedetail');
        //console.log("Started populating");
        const data = await response.json();
        this.setState({ invoices: data, unmergedInvoices: data, loading: false });
        //console.log("Finished populating");
    }

    async getInvoiceDetailData() {
        const response = await fetch('invoicedetail');
        const data = await response.json();
        return data;
    }

    async populateFileCountData() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: {}
        };
        const response = await fetch('invoicedetail/filecount', requestOptions);
        const data = await response.json();
        this.setState({ emailCount: data.emailCount, pdfCount: data.pdfCount, tempPdfs: data.pdfs });
    }

    async CheckDuplicates() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({param: 5})
        };
        const response = await fetch('invoicedetail/checkduplicates', requestOptions);
        const data = await response.json();

        if (data.length > 0) {
            var items = data.map(it => <li>{it}</li>);
            this.setState({ duplicateMessage: <div><ul>{items}</ul></div> });
            return true;
        } else {
            this.setState({ duplicateMessage: <p> None found.</p> });
            return false;
        };
        
    }

    async validateInvoice(targetInvoiceNumber) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(targetInvoiceNumber)
        };
        const response = await fetch('invoicedetail/validate', requestOptions);
        const data = await response.json();
        if (data === 1) {
            this.setState({ targetInvoiceStatusValid: true, contentsInvoiceStatus: <p></p> });
            return true;
        } else {
            this.setState({
                targetInvoiceStatusValid: false, contentsInvoiceStatus: <p style={{ color: "#AF2526" }}><em>Enter a valid Invoice Number, starting with 'S'...</em></p>
            });
            return false;
        };
        
    }

    async mergeInvoiceDetailData(mergeData) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mergeData)
        };
        this.setState({ mergeStatus: <p><em>running...</em></p> });
        const response = await fetch('invoicedetail/merge', requestOptions);
        const data = await response.json();
        if (data.status === "ok") {
            this.setState({ mergeStatus: <p style={{ color: "#228b22" }}><em>Merge Complete. </em></p> });
        }
    }

    async generateMasterBillPDF(mbNumber) {
        var steps = ["retrieving invoices", "processing invoices", "merging invoices"];
        var i;
        for (i = 0; i < steps.length; i++) {
            var mergeData = { InvoiceNumber: mbNumber, InvoicePOs: [i.toString()] };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(mergeData)
            };
            this.setState({ generateStatus: <p><em>{ steps[i] }...</em></p> });

            const response = await fetch('invoicedetail/generate', requestOptions);
            const data = await response.json();

            if (data.status !== "ok") {
                this.setState({ generateStatus: <p style={{ color: "RED" }}><em>Error generating Master Bill for { mbNumber }</em></p> });
                return;
            }
        }

        this.setState({ generateStatus: <p style={{ color: "#228b22" }}><em>Generate Complete. File saved to N:\Invoicing\Isonova\Social Circle\output</em></p> });
    }

    async parseEmails() {
            const response = await fetch('invoicedetail/parseemail');
            const data = await response.json();
        if (data.status === "notok") {
            this.setState({ generateStatusParseEmail: <p style={{ color: "#228b22" }}><em>Error: {data.error}</em></p> });
        } else {
            this.displayDuplicates(data.output);
            this.populateFileCountData();
        }
    }

    async importCopy() {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: "import" })
        };
        const response = await fetch('invoicedetail/importc', requestOptions);
        const data = await response.json();
        if (data.status === "ok") {
            return data;
        } else {
            alert("Copy Failed.");
        }
    }

    async importDelete(deleteList) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: deleteList })
        };
        const response = await fetch('invoicedetail/importd', requestOptions);
        const data = await response.json();
        if (data.status === "ok") {
            //console.log(data);
            return data;
        } else {
            alert("Delete Failed.");
        }
    }

    async cleanPdfs(invoicesToDelete) {
        if (invoicesToDelete.length === 0) {
            alert("Nothing to cleanup.");
            return;
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(invoicesToDelete.toString())
        };
        const response = await fetch('invoicedetail/clean', requestOptions);
        const data = await response.json();
        if (data.status === "notok") {
            this.setState({ generateStatusParseEmail: <p style={{ color: "#228b22" }}><em>Error: {data.error}</em></p> });
        } else {
            alert("Cleanup Successful.");
        }
    }
}
